import { Project, PageModel, Team } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';
import { 
    fetchTeams 
} from '../../actions/Teams/teamsActions';

interface TeamsSliceState {
    teamsList: Team<'Global'>[], 
    isTeamsLoading: boolean;
    currentTeam: Team<'Global'>;
}

export const TeamsSlice = createSlice({
    name: 'teams',
    initialState: {
        teamsList: [],
        isTeamsLoading: false,
        currentTeam: undefined
    },
    reducers: {
        setCurrent: (state, action) => {
            state.currentTeam = action.payload
        },
    },
    extraReducers: {
        [fetchTeams.fulfilled.toString()]: (state, action) => {
            state.teamsList = action.payload;
            state.isTeamsLoading = false;
        },
        [fetchTeams.rejected.toString()]: (state, action) => {
            state.isTeamsLoading = false;
        },
        [fetchTeams.pending.toString()]: (state, action) => {
            state.isTeamsLoading = true;
        },
    }
});

export default TeamsSlice
export const TeamsSliceActions = TeamsSlice.actions
export const TeamsSliceSelector = (store: { teams: TeamsSliceState }): TeamsSliceState => store.teams;
import { Project, PageModel, Team } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';
import { 
    fetchTeams 
} from '../../actions/Teams/teamsActions';

interface TeamsSliceState {
    teamsList: Team<'Global'>[], 
    isTeamsLoading: boolean;
    currentTeam: Team<'Global'>;
}

export const TeamsSlice = createSlice({
    name: 'teams',
    initialState: {
        teamsList: [],
        isTeamsLoading: false,
        currentTeam: undefined
    },
    reducers: {
        setCurrent: (state, action) => {
            state.currentTeam = action.payload
        },
    },
    extraReducers: {
        [fetchTeams.fulfilled.toString()]: (state, action) => {
            state.teamsList = action.payload;
            state.isTeamsLoading = false;
        },
        [fetchTeams.rejected.toString()]: (state, action) => {
            state.isTeamsLoading = false;
        },
        [fetchTeams.pending.toString()]: (state, action) => {
            state.isTeamsLoading = true;
        },
    }
});

export default TeamsSlice
export const TeamsSliceActions = TeamsSlice.actions
export const TeamsSliceSelector = (store: { teams: TeamsSliceState }): TeamsSliceState => store.teams;
